module.exports = __webpack_public_path__ + "static/img/img_honner_proc.2bb4801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_honner_proc.jpg
// module id = Uo2v
// module chunks = 1